module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "id": "_idContainer006",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "pl-center"
  }, [_vm._v("This story is dedicated to my faithful friend Elizabeth Tisdale. Thank you for always listening, appreciating my love for Disney movies and encouraging me to have fun. Here’s to all of the adventures we’ve had and all that are sure to come.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f12c72e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 75
// module chunks = 0